module.exports = __webpack_public_path__ + "img/masina.eed2106a.png";